













import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import PromoCodeLists from './components/PromoCodeLists.vue';

@Component({
    components: {
        PromoCodeLists
    }
})
export default class QuestManager extends Vue {
    tab = null;

    successMessage = false;
    error = {
        show: false,
        message: ''
    };

    public onError(err: any) {
        this.error.show = true;
        this.error.message = err.message;
    }
}
